module.exports = __webpack_public_path__ + "img/play-filled-plain.b3dbb54f.svg";